var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/User/Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.66659C5.42267 8.66659 3.33333 10.7559 3.33333 13.3333V14.6666C3.33333 15.0348 3.03486 15.3333 2.66667 15.3333C2.29848 15.3333 2 15.0348 2 14.6666V13.3333C2 10.0195 4.68629 7.33325 8 7.33325C11.3137 7.33325 14 10.0195 14 13.3333V14.6666C14 15.0348 13.7015 15.3333 13.3333 15.3333C12.9651 15.3333 12.6667 15.0348 12.6667 14.6666V13.3333C12.6667 10.7559 10.5773 8.66659 8 8.66659Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.33342C9.47276 7.33342 10.6667 6.13951 10.6667 4.66675C10.6667 3.19399 9.47276 2.00008 8 2.00008C6.52724 2.00008 5.33333 3.19399 5.33333 4.66675C5.33333 6.13951 6.52724 7.33342 8 7.33342ZM8 8.66675C10.2091 8.66675 12 6.87589 12 4.66675C12 2.45761 10.2091 0.666748 8 0.666748C5.79086 0.666748 4 2.45761 4 4.66675C4 6.87589 5.79086 8.66675 8 8.66675Z",
    fill: "#777E91"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.74f02cd4a705b6dec090ca5639d6933c.svg";
export { ForwardRef as ReactComponent };